// src/components/ErrorMessage.jsx
import PropTypes from 'prop-types';

export const ErrorMessage = ({ message }) => (
  <div className="p-4">
    <div className="bg-red-50 border-l-4 border-red-500 p-4">
      <div className="text-red-700">{message}</div>
    </div>
  </div>
);

ErrorMessage.propTypes = {
  message: PropTypes.string.isRequired
};

export default ErrorMessage;
